let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j8ml5")).then(() => parcelRequire('lEnLm'));